<template>
  <div class="brochure-request">
    <Loading v-if="loading" />

    <template v-else>
      <!-- If brochure request selection -->
      <div class="brochure-select" v-show="!isForm">
        <section class="section full-width">
          <div class="container-fluid">
            <div class="row">
              <div
                class="brochure-introduction"
                v-html="this.$store.state.brochureRequest.data.introductionHtml"
              ></div>
            </div>
          </div>
        </section>

        <section class="section full-width">
          <div class="container-fluid">
            <ul class="brochure-list">
              <li
                class="brochure-list__item"
                v-for="brochure in brochures"
                :key="brochure.uniqueId"
              >
                <Brochure @brochureSelected="brochureSelected" :brochure="brochure" />
              </li>
            </ul>
          </div>
          <div id="popup" class="white-popup mfp-hide">
              <form :id="'mktoForm_' + (data.brand === 'Travelsphere' ? '2410' : '2405')"></form>
          </div>
        </section>

        <BrochureConfirmBar :brandName="data.brand" />
      </div>

      <!-- Else if brochure form stage -->
      <div class="brochure-selected-details" v-show="isForm">
        <section class="section full-width">
          <div class="container-fluid">
            <div class="brochure-selected-details-row">
              <div class="brochure-form-col">
                <BrochureForm />
              </div>
              <div class="brochure-selection-col">
                <BrochureSelection :brandName="data.brand" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .white-popup {
    position: relative;
    background: #FFF;
    padding: 20px;
    width: auto;
    max-width: 500px;
    margin: 20px auto;
  }
</style>

<script>
import { mapState } from 'vuex';
import Brochure from './Brochure.vue';
import BrochureConfirmBar from './BrochureConfirmBar.vue';
import BrochureForm from './BrochureForm.vue';
import BrochureSelection from './BrochureSelection.vue';
import Loading from '../Form/Loading.vue';

var selectedBrochure = null;

export default {
  
  components: {
    Brochure,
    BrochureConfirmBar,
    BrochureForm,
    BrochureSelection,
    Loading
  },
  props: ['data'],
  data() {
    return {};
  },
  computed: {
    ...mapState('brochureRequest', ['brochures', 'isForm', 'loading'])
  },
  methods: {
    brochureSelected(brochure) {
      selectedBrochure = brochure;
    },
    getUtmParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {
        utmSource: urlParams.get('utm_source') || null,
        utmMedium: urlParams.get('utm_medium') || null,
      };
      return utmParams;
    }
  },
  created() {
    this.$store.commit('brochureRequest/setData', this.data);
    this.$store.dispatch('brochureRequest/requestBrochures');
    const utmParams = this.getUtmParams();

    const scriptTag = document.createElement('script');
    scriptTag.src = "//letsgo.gadventures.com/js/forms2/js/forms2.min.js";
    scriptTag.setAttribute('charset', 'utf-8');

    var formId = this.data.brand === 'Travelsphere' ? '2410' : '2405';
    scriptTag.onload = function() {
      MktoForms2.loadForm("//letsgo.gadventures.com", "110-AIL-152", formId, function(form) {
        form.vals({"Referral__c":utmParams.utmSource, "Inquiry_Subcategory__c_account":utmParams.utmMedium});
        form.onSuccess(function(values, followUpUrl) {
          $.magnificPopup.instance.close();
          GTM.brochureRequestEmail(selectedBrochure.code, {
            country: values.Country,
            email: values.Email,
            firstName: values.FirstName,
            lastName: values.LastName,
            postal: '0',
            referralSource: values.Referral__c,
            referralDetail: values.Inquiry_Subcategory__c_account,
            phone: values.phone
          }, "download");
          window.open(selectedBrochure.downloadLink, '_blank');
          return false;
        });
    }); 
    };
    document.head.appendChild(scriptTag);
  }
};
</script>
